export default {"src":"/_next/static/media/BranchesFinal.48ddf16f.svg","height":66,"width":73,"blurWidth":0,"blurHeight":0};